import ExcelJS from 'exceljs'
import { Fieldset } from 'primereact/fieldset'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { SplitButton } from 'primereact/splitbutton'
import * as colors from '../../../../assets/js/colors'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  BadgeStatusEntrega,
  Btn,
  Cnpj,
  CustomCalendar,
  CustomDataTableHeader,
  CustomMultiSelect,
  CustomPanel,
  DateTime,
  Loading,
  NumeroDecimal,
  PageHeader,
  SelectEmpresas,
  ThreeDots,
} from '../../../../components'
import Badge from '../../../../components/Badge/Badge'
import { useEntregasPorEmpresaContext } from '../../../../contexts/EntregaContext'
import useShowReleaseStatus from '../useShowReleaseStatus'
import {
  getDeliveriesPerCompany,
  getTimelineInfoToBeExported,
} from '../../../../services/api/https/deliveries/delivery.http'
import {
  urlReportRelatorioEmbarcador,
  urlReportRelatorioEmbarcadorExcel,
} from '../../../../services/api/routes/deliveries.routes'
import { isRouteAllowed } from '../../../../services/permission/menus'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { selectedEmpresaChanged } from '../../../../store/actions/entrega-por-empresa.action'
import { showMessageBox } from '../../../../store/actions/system.actions'
import ModalAlterarNfIdentificador from './ModalAlterarNfIdentificador'
import ModalAlterarStatus from './ModalAlterarStatus'

function EntregasPorEmpresa({ history, dispatch, selectedTp, empresaId }) {
  // Vars

  // Hooks
  const context = useEntregasPorEmpresaContext()
  const [isLoading, setIsLoading] = useState(false)
  const [entregas, setEntregas] = useState([])
  const [filterdEntregas, setFilterdEntregas] = useState([])
  const [selectedEmpresa, setSelectedEmpresa] = useState(empresaId)
  const [pInicial, setPeriodoInicial] = useState(
    context.entregasPorEmpresaContext.selectedPeriodo.dataInicial,
  )
  const [pFinal, setPeriodoFinal] = useState(
    context.entregasPorEmpresaContext.selectedPeriodo.dataFinal,
  )
  const [modalAlterarStatus, setModalAlterarStatus] = useState({ show: false, data: null })
  const [modalAlterarNfIdentificador, setModalAlterarNfIdentificador] = useState({
    show: false,
    data: null,
  })
  const [statusFilter, setStatusFilter] = useState([])
  const [deliveryStatus, setDeliveryStatus] = useState([])
  const [cycleSelected, setCycleSelected] = useState([])
  const [cyclesOptions, setCyclesOptions] = useState([])
  const [selectedEmpresaObj, setSelectedEmpresaObj] = useState(null)
  const canAlterarNfIdentificador = isRouteAllowed(52)
  // Status de liberação (suspenso/liberado): só exibido para TPs com a opção ligada
  const showReleaseStatus = useShowReleaseStatus(selectedTp)
  const canAlterarStatus = isRouteAllowed(143)

  // Events
  const onMenuItemClicked = (item, delivery) => {
    switch (item) {
      case 'Detalhes':
        history.push('/main/entregas/entrega-detalhes', { entrega: delivery, showReleaseStatus })
        break

      case 'Alterar status':
        if (!canAlterarStatus) return
        setModalAlterarStatus({ show: true, data: delivery })
        break

      case 'Alterar NF/Identificador':
        if (!canAlterarNfIdentificador) return
        setModalAlterarNfIdentificador({ show: true, data: delivery })
        break

      default:
        break
    }
  }

  const onEmpresaChange = empresa => {
    context.setEntregasPorEmpresaContext(prevEntregasPorEmpresaContext => ({
      ...prevEntregasPorEmpresaContext,
      selectedEmpresa: empresa.id,
    }))
    setSelectedEmpresa(empresa.id)
    setSelectedEmpresaObj(empresa)
    dispatch(selectedEmpresaChanged(empresa.id))
  }

  const onModalSave = delivery => {
    setEntregas(prevEntregas => {
      const index = prevEntregas.findIndex(entrega => entrega.delivery_id === delivery.delivery_id)
      if (index !== -1) {
        prevEntregas[index] = delivery
      }
      return [...prevEntregas]
    })
    setModalAlterarStatus({ show: false, data: null })
    setModalAlterarNfIdentificador({ show: false, data: null })
  }

  // Helpers
  const fetchEntregasPorEmpresa = async () => {
    try {
      if (selectedTp === 0) throw new Error('Selecione o Operador Logístico')
      if (selectedEmpresa === '') throw new Error('Selecione a Empresa Desejada')

      setIsLoading(true)
      const fetchedEntregas = await getDeliveriesPerCompany(
        selectedTp,
        selectedEmpresa,
        pInicial,
        pFinal,
      )
      setStatusFilter([])
      setCycleSelected([])
      setEntregas(fetchedEntregas)
      setFilterdEntregas(fetchedEntregas)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  const exportarExcel = () => {
    try {
      if (filterdEntregas.length === 0) throw new Error('Não existe entrega para exportação')
      const rows = [
        [
          'Identificador',
          'Nota Fiscal',
          'CNPJ',
          'Cidade',
          'Cliente',
          'Qte. CX',
          'Peso',
          'Valor Total',
          'Tipo de Ciclo',
          'Data Status',
          'Status',
          'Ciclo de Entrega',
        ],
      ]
      filterdEntregas.forEach(e => {
        rows.push([
          e.identifier,
          e.invoice_number,
          e.cnpj,
          e.city,
          e.nomeFantasia,
          Number(e.qteSkuTotal),
          Number(e.weightTotal),
          Number(e.valor_nf),
          e.cycle_type,
          new Date(e.dt_status).toLocaleDateString(),
          e.status,
          e.cycle_id ? e.cycle_id + ' - ' + e.cycle_name : '',
        ])
      })

      gerarArquivoExcel('entregasAnalitico', rows, 'entregas_analitico.xlsx')
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const exportarExcelTimeline = async () => {
    try {
      if (selectedTp === 0) throw new Error('Selecione o Operador Logístico')
      if (selectedEmpresa === '') throw new Error('Selecione a Empresa Desejada')

      setIsLoading(true)
      const timelineInfo = await getTimelineInfoToBeExported(
        selectedTp,
        selectedEmpresa,
        pInicial,
        pFinal,
      )
      // Build Excel
      const rows = [
        [
          'Data Importação',
          'Data Status',
          'Status',
          'Veiculo de Transferência',
          'Veículo de Entrega',
          'Identificador',
          'Peso',
          'Valor NF',
        ],
      ]
      timelineInfo.forEach(info => {
        const {
          data_importacao,
          data_status,
          status,
          veiculo_transferencia,
          veiculo_entrega,
          identificador,
          peso,
          valor_nf,
        } = info
        rows.push([
          data_importacao,
          data_status,
          status,
          veiculo_transferencia,
          veiculo_entrega,
          identificador,
          peso,
          valor_nf,
        ])
      })
      gerarArquivoExcel('info', rows, 'timeline.xlsx')
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  const gerarRelatorioEmbarcador = () => {
    try {
      if (selectedTp === 0) throw new Error('Selecione o Operador Logístico')
      if (selectedEmpresa === '') throw new Error('Selecione a Empresa Desejada')

      const url = urlReportRelatorioEmbarcador(selectedTp, selectedEmpresa, pInicial, pFinal)
      window.open(url, '_blank')
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const gerarRelatorioEmbarcadorExcel = async () => {
    try {
      if (selectedTp === 0) throw new Error('Selecione o Operador Logístico')
      if (selectedEmpresa === '') throw new Error('Selecione a Empresa Desejada')

      setIsLoading(true)
      const url = urlReportRelatorioEmbarcadorExcel(selectedTp, selectedEmpresa, pInicial, pFinal)
      const response = await fetch(url)
      if (!response.ok) throw new Error('Erro ao buscar dados do relatório')
      const data = await response.json()

      await gerarExcelRelatorioEmbarcador(data)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setPeriodoFinal(context.entregasPorEmpresaContext.selectedPeriodo.dataFinal)
    setPeriodoInicial(context.entregasPorEmpresaContext.selectedPeriodo.dataInicial)
    if (context.entregasPorEmpresaContext.selectedEmpresa !== '') {
      setSelectedEmpresa(context.entregasPorEmpresaContext.selectedEmpresa)
      fetchEntregasPorEmpresa()
    }
  }, [])

  useEffect(() => {
    if (!entregas.length) return

    const filtered = entregas.filter(e => {
      const statusOk = !statusFilter.length || statusFilter.includes(e.status)
      const cycleOk = !cycleSelected.length || cycleSelected.includes(e.cycle_type)
      return statusOk && cycleOk
    })

    setFilterdEntregas(filtered)
  }, [statusFilter, cycleSelected, entregas])

  useEffect(() => {
    setDeliveryStatus(
      [...new Set(entregas.map(e => e.status))].map(status => ({
        label: status,
        value: status,
      })),
    )
    setCyclesOptions(
      [...new Set(entregas.map(e => e.cycle_type))].map(cycle => ({
        label: cycle,
        value: cycle,
      })),
    )
  }, [entregas])

  const splitButtonsItems = [
    {
      label: 'Exportar em Excel',
      command: gerarRelatorioEmbarcadorExcel,
    },
  ]

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        3.9 - Entregas Por Empresa -&nbsp;<strong>Analítico</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <SelectEmpresas onChange={onEmpresaChange} companyId={selectedEmpresa} />
            </div>
            <div className="p-col-6" style={{ display: 'flex' }}>
              <CustomCalendar
                label="Período Inicial"
                value={pInicial}
                onChange={value => {
                  context.setEntregasPorEmpresaContext(prevEntregasPorEmpresaContext => ({
                    ...prevEntregasPorEmpresaContext,
                    selectedPeriodo: {
                      ...prevEntregasPorEmpresaContext.selectedPeriodo,
                      dataInicial: value,
                    },
                  }))
                  setPeriodoInicial(value)
                }}
              />
              <CustomCalendar
                label="Período Final"
                value={pFinal}
                onChange={value => {
                  context.setEntregasPorEmpresaContext(prevEntregasPorEmpresaContext => ({
                    ...prevEntregasPorEmpresaContext,
                    selectedPeriodo: {
                      ...prevEntregasPorEmpresaContext.selectedPeriodo,
                      dataFinal: value,
                    },
                  }))
                  setPeriodoFinal(value)
                }}
              />
            </div>
            <div className="p-col-12" style={{ marginRight: 10 }}>
              <Fieldset legend="Filtro" toggleable className="p-col-12" collapsed={true}>
                <div className="p-grid p-align-center">
                  <div className="p-col-3">
                    <CustomMultiSelect
                      showLabel={true}
                      label="Tipo de Ciclo"
                      marginTop={10}
                      options={cyclesOptions}
                      value={cycleSelected}
                      onChange={e => setCycleSelected(e)}
                    />
                  </div>
                  <div className="p-col-3">
                    <CustomMultiSelect
                      showLabel={true}
                      label="Status"
                      marginTop={10}
                      options={deliveryStatus}
                      value={statusFilter}
                      onChange={e => setStatusFilter(e)}
                    />
                  </div>
                </div>
              </Fieldset>
            </div>
            <div className="p-col-12" style={{ display: 'flex' }}>
              <div style={{ marginLeft: 10 }}>
                <Btn isLoading={isLoading} onClick={fetchEntregasPorEmpresa}>
                  Pesquisar
                </Btn>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <Btn onClick={exportarExcel}>Exportar Excel</Btn>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <Btn isLoading={isLoading} onClick={exportarExcelTimeline}>
                  Exportar Timeline
                </Btn>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <SplitButton
                  className="bck-primary"
                  label="Relatório Embarcador"
                  icon="pi pi-file-pdf"
                  onClick={gerarRelatorioEmbarcador}
                  model={splitButtonsItems}
                />
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <Btn
                  onClick={() => {
                    if (filterdEntregas.length === 0) {
                      dispatch(
                        showMessageBox(null, 'Não existem entregas para gerar o arquivo OCORREN'),
                      )
                      return
                    }
                    const empresaNome = selectedEmpresaObj ? selectedEmpresaObj.name : ''
                    history.push('/main/entregas/gerar-ocorren', {
                      entregas: filterdEntregas,
                      empresaNome,
                    })
                  }}
                >
                  Gerar Proceda - OCORREN
                </Btn>
              </div>
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            {isLoading ? (
              <div className="text-center">
                <Loading />
              </div>
            ) : (
              <EntregasDataTable
                entregas={filterdEntregas}
                onMenuItemClicked={onMenuItemClicked}
                canAlterarNfIdentificador={canAlterarNfIdentificador}
                canAlterarStatus={canAlterarStatus}
                showReleaseStatus={showReleaseStatus}
              />
            )}
          </div>
        </CustomPanel>
      </div>
      <ModalAlterarStatus
        show={modalAlterarStatus.show}
        data={modalAlterarStatus.data}
        onModalClose={() => {
          setModalAlterarStatus({ show: false, data: null })
        }}
        onModalSave={onModalSave}
      />
      {canAlterarNfIdentificador ? (
        <ModalAlterarNfIdentificador
          show={modalAlterarNfIdentificador.show}
          data={modalAlterarNfIdentificador.data}
          tpId={selectedTp}
          onModalClose={() => {
            setModalAlterarNfIdentificador({ show: false, data: null })
          }}
          onModalSave={onModalSave}
        />
      ) : null}
    </React.Fragment>
  )
}

async function gerarExcelRelatorioEmbarcador(data) {
  const { embarcador, periodo, total_entregas, status_resumo, entregas } = data

  if (!entregas || entregas.length === 0) {
    throw new Error('Não existem entregas para exportação')
  }

  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet('Relatório')

  // Título
  sheet.mergeCells('A1:K1')
  sheet.getCell('A1').value = `Relatório de Embarcador - ${embarcador}`
  sheet.getCell('A1').font = { bold: true, size: 14 }
  sheet.getCell('A1').alignment = { horizontal: 'left' }

  // Período
  sheet.getCell('A3').value = 'Período'
  sheet.getCell('A3').font = { bold: true }
  sheet.mergeCells('B3:D3')
  sheet.getCell('B3').value = periodo
  sheet.getCell('B3').alignment = { horizontal: 'left' }

  // Total de Entregas
  sheet.getCell('A5').value = 'Total de Entregas'
  sheet.getCell('A5').font = { bold: true }
  sheet.getCell('B5').value = total_entregas
  sheet.getCell('B5').alignment = { horizontal: 'left' }

  sheet.addRow([]) // Linha vazia

  // Tabela de Resumo de Status
  sheet.getCell('A7').value = 'Resumo por Status'
  sheet.getCell('A7').font = { bold: true, size: 12 }

  sheet.addRow([]) // Linha vazia

  // Cabeçalho da tabela de resumo
  const headerResumo = sheet.addRow(['Status', 'Qte', '%'])
  headerResumo.eachCell(cell => {
    cell.font = { bold: true }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
    cell.alignment = { horizontal: 'center' }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' },
    }
  })

  // Dados do resumo
  status_resumo.forEach(item => {
    const row = sheet.addRow([item.status, item.qte, item.percent])
    row.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }
      if (colNumber === 2 || colNumber === 3) {
        cell.alignment = { horizontal: 'center' }
      }
    })
  })

  sheet.addRow([]) // Linha vazia
  sheet.addRow([]) // Linha vazia

  // Tabela Principal de Entregas
  const currentRow = sheet.lastRow.number + 1
  sheet.getCell(`A${currentRow}`).value = 'Entregas'
  sheet.getCell(`A${currentRow}`).font = { bold: true, size: 12 }

  sheet.addRow([]) // Linha vazia

  // Cabeçalho da tabela principal
  const headerEntregas = sheet.addRow([
    'Identificador',
    'Nota Fiscal',
    'Cliente',
    'Cidade',
    'Peso',
    'CNPJ',
    'Qte CX',
    'Motorista',
    'Placa',
    'Status',
    'Data Status',
  ])

  headerEntregas.eachCell(cell => {
    cell.font = { bold: true }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
    cell.alignment = { horizontal: 'center' }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' },
    }
  })

  // Dados das entregas
  entregas.forEach(entrega => {
    const row = sheet.addRow([
      entrega.identificador ? entrega.identificador : '',
      entrega.nota_fiscal ? entrega.nota_fiscal : '',
      entrega.cliente ? entrega.cliente : '',
      entrega.cidade ? entrega.cidade : '',
      entrega.peso ? entrega.peso : '',
      entrega.cnpj ? entrega.cnpj : '',
      entrega.qte_cx ? entrega.qte_cx : '',
      entrega.motorista ? entrega.motorista : '',
      entrega.placa ? entrega.placa : '',
      entrega.status ? entrega.status : '',
      entrega.data_status ? entrega.data_status : '',
    ])

    row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }
      // Centralizar
      const centerColumns = [1, 2, 4, 5, 6, 7, 8, 9, 10, 11]
      if (centerColumns.includes(colNumber)) {
        cell.alignment = { horizontal: 'center' }
      }
    })
  })

  // Ajustando largura das colunas
  sheet.getColumn('A').width = 15 // Identificador
  sheet.getColumn('B').width = 15 // Nota Fiscal
  sheet.getColumn('C').width = 40 // Cliente
  sheet.getColumn('D').width = 20 // Cidade
  sheet.getColumn('E').width = 12 // Peso
  sheet.getColumn('F').width = 18 // CNPJ
  sheet.getColumn('G').width = 10 // Qte CX
  sheet.getColumn('H').width = 25 // Motorista
  sheet.getColumn('I').width = 12 // Placa
  sheet.getColumn('J').width = 25 // Status
  sheet.getColumn('K').width = 15 // Data Status

  // Gerar arquivo Excel
  const buffer = await workbook.xlsx.writeBuffer()

  // Download
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `relatorio_${embarcador.toLowerCase().replace(/\s+/g, '_')}.xlsx`
  a.click()
  window.URL.revokeObjectURL(url)
}

function EntregasDataTable({
  entregas,
  onMenuItemClicked,
  canAlterarNfIdentificador,
  canAlterarStatus,
  showReleaseStatus,
}) {
  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')

  // Events

  // Render
  return (
    <DataTable
      value={entregas}
      emptyMessage="Nenhuma Entrega foi Encontrada"
      header={<CustomDataTableHeader value={globalFilter} onChange={setGlobalFilter} />}
      globalFilter={globalFilter}
      rows={20}
      paginator={true}
      className="auto-layout"
    >
      <Column field="identifier" header="Identificador" style={tableCellCentered(110)} />
      <Column field="invoice_number" header="NF Entrega" style={tableCellCentered()} />
      <Column
        field="nomeFantasia"
        header="CNPJ/Fantasia"
        body={entrega => (
          <>
            <Cnpj>{entrega.cnpj}</Cnpj> - {entrega.nomeFantasia}
          </>
        )}
      />
      <Column field="city" header="Cidade" style={tableCellCentered(160)} />
      <Column field="qteSkuTotal" header="Qte. Cxs" style={tableCellCentered(80)} />
      <Column
        field="weightTotal"
        header="Peso"
        body={entrega => <NumeroDecimal>{entrega.weightTotal}</NumeroDecimal>}
        style={tableCellCentered(100)}
      />
      <Column
        field="cicle_type"
        header="Ciclo"
        body={entrega => <Badge color={colors.black}>{entrega.cycle_type}</Badge>}
        style={tableCellCentered(95)}
      />
      <Column
        header="Dt. Status"
        body={entrega => <DateTime>{entrega.dt_status}</DateTime>}
        style={tableCellCentered(120)}
      />
      <Column
        field="status"
        header="Status"
        body={entrega => <BadgeStatusEntrega status={entrega.status} />}
        style={tableCellCentered(170)}
      />
      {showReleaseStatus && (
        <Column
          field="release_status"
          header="Liberação"
          body={entrega =>
            entrega.release_status === 'suspended' ? (
              <span title={entrega.release_status_reason || 'Entrega suspensa'}>
                <Badge color={colors.vinho}>Suspenso</Badge>
              </span>
            ) : (
              'Liberado'
            )
          }
          style={tableCellCentered(110)}
        />
      )}
      <Column
        header="Menu"
        style={tableCellCentered(70)}
        body={delivery => (
          <ThreeDots
            items={[
              'Detalhes',
              ...(canAlterarStatus ? ['Alterar status'] : []),
              ...(canAlterarNfIdentificador ? ['Alterar NF/Identificador'] : []),
            ]}
            onClick={item => onMenuItemClicked(item, delivery)}
          />
        )}
        bodyStyle={tableCellCentered()}
      />
    </DataTable>
  )
}

const mapStateToProps = ({ system: { selectedTp }, entrega_por_empresa: { empresaId } }) => ({
  selectedTp,
  empresaId,
})
export default connect(mapStateToProps)(withRouter(EntregasPorEmpresa))
